import { useState, useEffect } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ChannelSection from '../components/ChannelSection';
import SubmissionApprovalSection from '../components/SubmissionApprovalSection';
import 'react-toastify/dist/ReactToastify.css';
import { jwtDecode } from 'jwt-decode';
import routes from '../api_routes';

import './UploadPage.css';

function UploadPage() {
  const [username, setUsername] = useState(''); // Replace with logic to fetch actual username
  const [channelData, setChannelData] = useState(null); // avatar_img, banner_img, description, name, playlist_id, trailer_img, trailer_url, vip
  const [submissionsData, setSubmissionsData] = useState(null);

  const channelApiUrl = routes.channel;
  const submissionsApiUrl = routes.submissions;
  
  useEffect( () => {
    const getUserData = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        const decoded = jwtDecode(token);
        setUsername(decoded['sub']);
        
        const channel = await axios.get(channelApiUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setChannelData(channel.data);
      }
    };

    const getSubmissionData = async() => {
      const token = localStorage.getItem('token');
      if(token) {
        const submissions = await axios.get(submissionsApiUrl, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        setSubmissionsData(submissions.data);
      }
    }

    getUserData();
    getSubmissionData();
  }, [channelApiUrl]);

  return (
    <div className="PortalPage">
      <span>
        <img src="/hearthfire-logo.png" alt="Hearthfire Radio" className="LogoSmall"></img>
        <h3>Creator Portal</h3>
      </span>
      <p>Signed in as {username}</p>
      
      <h3>New Submissions</h3>
      <p>Click 'Approve' to post a submitted episode to Hearthfire. There may be a short processing time of a few minutes.</p>
      {submissionsData && submissionsData.length > 0 ?
        submissionsData.map((submission, index) => {
          return <SubmissionApprovalSection key={submission.channel} initialData={submission} toastContainer={toast}></SubmissionApprovalSection>
        }) : <div>No submissions to approve</div>}

      {channelData && 
      channelData.map((channel, index) => (
        <ChannelSection key={channel.name} initialData={channel} toastContainer={toast} startExpanded={(channelData.length === 1)}></ChannelSection>
      ))}
      
      <ToastContainer />
    </div>
  );
}

export default UploadPage;